import { SupportTicketType } from './SupportTicket.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

// We include data from all support ticket types as unknown, since we only need to know if they are defined in order the map the type

class SupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      id: response.id,
      status: response.status,
      externalReference: response.external_reference,
      type: this.getTypeFromSupportTicket(response),
      createdAt: response.created_at,
      updatedAt: response.updated_at
    };
  }
  static getTypeFromSupportTicket(response) {
    if (response.pickup) {
      return SupportTicketType.PICKUP;
    } else if (response.loss) {
      return SupportTicketType.LOSS;
    } else if (response.damage) {
      return SupportTicketType.DAMAGE;
    } else if (response.cancel) {
      return SupportTicketType.CANCEL;
    } else if (response.label) {
      return SupportTicketType.LABEL;
    } else if (response.delivery) {
      return SupportTicketType.DELIVERY;
    } else if (response.billing) {
      return SupportTicketType.BILLING;
    } else if (response.other) {
      return SupportTicketType.OTHER;
    } else {
      return SupportTicketType.UNKNOWN;
    }
  }
}

export { SupportTicketMapper };
//# sourceMappingURL=SupportTicketMapper.js.map
